import Joi from '@hapi/joi';
import { SendCommunicationCustomersSelection, SendCommunicationFirstStepForm } from 'types';

import validate from '../validate';

type Params = {
  isOnlyConflictedTickets?: boolean;
  isPurchaseComparisonSelected?: boolean;
  customersSelection: SendCommunicationCustomersSelection;
};

const schemaClientType = (params: Omit<Params, 'targetType'>) => {
  const isAllCustomers = params.customersSelection === SendCommunicationCustomersSelection.All;

  return Joi.object<SendCommunicationFirstStepForm>({
    customersSelection: Joi.number().required().messages({
      'number.required': 'REQUIRED_FIELD',
    }),
    impactedStations: !isAllCustomers
      ? Joi.array().items(Joi.string().required()).required().min(1).messages({
          'array.min': 'INCOMPLETE_ERROR',
        })
      : Joi.array(),
    excludedStations: Joi.array().items(Joi.string()),
    selectedCarriages: Joi.array().required().min(1).messages({
      'array.min': 'INCOMPLETE_ERROR',
    }),
    includePassengersWithoutSeats: Joi.bool().required().messages({
      'bool.required': 'REQUIRED_FIELD',
    }),
    selectedConflictTypeId: params.isOnlyConflictedTickets
      ? Joi.number().required().messages({
          'any.required': 'INCOMPLETE_ERROR',
          'number.empty': 'INCOMPLETE_ERROR',
          'number.base': 'INCOMPLETE_ERROR',
        })
      : Joi.optional(),
    purchaseReferenceDate: params.isPurchaseComparisonSelected
      ? Joi.string().required().messages({
          'any.required': 'INCOMPLETE_ERROR',
          'string.empty': 'INCOMPLETE_ERROR',
          'string.base': 'INCOMPLETE_ERROR',
        })
      : Joi.optional(),
    purchaseReferenceTime: params.isPurchaseComparisonSelected
      ? Joi.string().required().messages({
          'any.required': 'INCOMPLETE_ERROR',
          'string.empty': 'INCOMPLETE_ERROR',
          'string.base': 'INCOMPLETE_ERROR',
        })
      : Joi.optional(),
  });
};

const schemaDVNumbers = () => {
  return Joi.object<SendCommunicationFirstStepForm>({
    DVNumbers: Joi.string().required().messages({
      'any.required': 'INCOMPLETE_ERROR',
      'string.empty': 'INCOMPLETE_ERROR',
      'string.base': 'INCOMPLETE_ERROR',
    }),
  });
};

export const schema = (
  params: Params = {
    isOnlyConflictedTickets: false,
    isPurchaseComparisonSelected: false,
    customersSelection: SendCommunicationCustomersSelection.All,
  }
) => {
  if (params.customersSelection === SendCommunicationCustomersSelection.DVNumbers) {
    return schemaDVNumbers();
  }
  return schemaClientType({
    isOnlyConflictedTickets: params.isOnlyConflictedTickets,
    isPurchaseComparisonSelected: params.isPurchaseComparisonSelected,
    customersSelection: params.customersSelection,
  });
};

export default function (value: SendCommunicationFirstStepForm, params: Params) {
  return validate(
    schema({
      isOnlyConflictedTickets: params?.isOnlyConflictedTickets,
      isPurchaseComparisonSelected: params?.isPurchaseComparisonSelected,
      customersSelection: params.customersSelection,
    }),
    value,
    {
      allowUnknown: true,
      context: {},
    }
  );
}
